"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swap_multicall_1 = __importDefault(require("./swap-multicall"));
const swap_contract_1 = __importDefault(require("./swap-contract"));
const swap_balance_1 = __importDefault(require("./swap-balance"));
const providers_1 = require("@ethersproject/providers");
const normalizers_1 = require("./utils/normalizers");
const web3_utils_1 = require("web3-utils");
const erc_721_1 = __importDefault(require("./erc-721"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const nftccdao_json_1 = __importDefault(require("./abis/nftccdao.json"));
class NFTDao {
    constructor(options) {
        const { web3, chainId, multicallAddress, nftDaoContract } = options;
        const account = (0, normalizers_1.normalizeAccount)(options.account);
        this.account = account;
        const currentProvider = web3.currentProvider;
        const library = new providers_1.Web3Provider(currentProvider, chainId);
        this.swapContract = new swap_contract_1.default(account, multicallAddress, library);
        this.swapMulticall = new swap_multicall_1.default(chainId, web3, this.swapContract);
        this.swapBalance = new swap_balance_1.default(this.swapMulticall);
        this.nftDaoContract = this.swapContract.useContract(nftDaoContract, nftccdao_json_1.default, true);
    }
    /**
     * 初始化721合约
     *
     * @param {string} token Token721
     * @returns {ERC721}
     * @memberof NFTDao
     */
    initERC721(token) {
        return new erc_721_1.default(this.account, token, this.swapMulticall, this.swapContract);
    }
    /**
     * 获取CHA合约经营权地址
     *
     * @returns {Promise<string>}
     * @memberof ChaSwap
     */
    async admin() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.nftDaoContract, "admin");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    /**
     * 获取CHA合约所有权地址
     *
     * @returns {Promise<string>}
     * @memberof ChaSwap
     */
    async owner() {
        var _a;
        const res = await this.swapMulticall.useSingleCallResult(this.nftDaoContract, "owner");
        return (_a = res === null || res === void 0 ? void 0 : res.result) === null || _a === void 0 ? void 0 : _a[0];
    }
    /**
     * 放弃合约所有权
     *
     * @returns
     * @memberof ChaSwap
     */
    async renounceOwnership() {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.renounceOwnership({
            from: this.account
        }));
        return result;
    }
    /**
     * 转移合约经营权
     *
     * @param {string} newAdmin
     * @returns
     * @memberof ChaSwap
     */
    async transferAdministrator(newAdmin) {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.transferAdministrator(newAdmin, {
            from: this.account
        }));
        return result;
    }
    /**
     * 转移合约所有权
     *
     * @param {string} newOwner
     * @returns
     * @memberof ChaSwap
     */
    async transferOwnership(newOwner) {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.transferOwnership(newOwner, {
            from: this.account
        }));
        return result;
    }
    withdrawHistory() { }
    onERC721Received() { }
    /**
     * 设置手续费
     *
     * @param {number} fee
     * @returns
     * @memberof ChaSwap
     */
    async setFee(fee) {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.setFee((0, web3_utils_1.toWei)(new bignumber_js_1.default(fee).toString()), {
            from: this.account
        }));
        return result;
    }
    withdrawFee() { }
    /**
       *
       * 充币
       *
       * 从以太坊到井通
       *
       * @param {string} nft nft合约地址
       * @param {number} id nft id
       * @param {string} jtaddress 井通地址
          * @param {number} [fee=0] 手续费，默认为0
  
       * @returns {Promise<number>}
       * @memberof NFTDao
       */
    async deposit(nft, id, jtaddress, fee = 0) {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.deposit(nft, id, jtaddress, {
            value: (0, web3_utils_1.toWei)(new bignumber_js_1.default(fee).toString()),
            from: this.account
        }));
        return result;
    }
    /**
     * 提币
     *
     * 从井通到以太坊
     *
     * @param {string} nft nft合约地址
     * @param {string} to 目的地，以太坊地址
     * @param {number} id nft id
     * @param {string} jthash 井通hash
     * @returns {Promise<number>}
     * @memberof NFTDao
     */
    async withdraw(nft, to, id, jthash) {
        var _a;
        const result = await ((_a = this.nftDaoContract) === null || _a === void 0 ? void 0 : _a.withdraw(nft, to, id, jthash, {
            from: this.account
        }));
        return result;
    }
}
exports.default = NFTDao;
